"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlRevenueEstimationParamsModel = void 0;
const validator_1 = require("@leavy/validator");
const Address_1 = require("../../common/model/Address");
class HlRevenueEstimationParamsModel {
}
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsDateString)(),
    __metadata("design:type", String)
], HlRevenueEstimationParamsModel.prototype, "departureDate", void 0);
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsDateString)(),
    __metadata("design:type", String)
], HlRevenueEstimationParamsModel.prototype, "returnDate", void 0);
__decorate([
    (0, validator_1.Type)(() => Address_1.AddressModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", Address_1.AddressModel)
], HlRevenueEstimationParamsModel.prototype, "address", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlRevenueEstimationParamsModel.prototype, "bedrooms", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    __metadata("design:type", Number)
], HlRevenueEstimationParamsModel.prototype, "maxOccupancy", void 0);
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlRevenueEstimationParamsModel.prototype, "bathrooms", void 0);
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    __metadata("design:type", Number)
], HlRevenueEstimationParamsModel.prototype, "beds", void 0);
exports.HlRevenueEstimationParamsModel = HlRevenueEstimationParamsModel;
//# sourceMappingURL=HlRevenueEstimationModel.js.map